<!--suppress HtmlUnknownAttribute -->
<script lang="ts">
    import {svgContents} from './svg-contents';

    interface Props {
        name: keyof typeof svgContents;
        viewBox?: string;
        width?: string | undefined
        height?: string | undefined
        fill?: string;
        background?: string | undefined;
        border?: string | undefined;
        style?: string | undefined;
    }

    // prettier-ignore
    let {
        name,
        viewBox = '0 0 32 32',
        width,
        height,
        fill = 'currentcolor',
        background,
        border,
        style,
    }: Props = $props()

</script>

<!-- svelte-ignore a11y_click_events_have_key_events  a11y-no-static-element-interactions -->
<svg xmlns="http://www.w3.org/2000/svg" {width} {height} {viewBox}
     role="button"
     style="fill-rule:evenodd; {style}"
     {fill}
     style:background
     style:border
     tabindex="-1"
>
    {@html svgContents[name]}
</svg>

<!--suppress CssUnresolvedCustomProperty -->
<style>
    svg {
        display: block;
        transition: fill 100ms;
    }

    :focus {
        outline: none;
    }
</style>